import React, { FC, Children, ButtonHTMLAttributes, ReactNode, CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';

import Popup from 'components/common/Popup';

import styles from './styles.module.scss';

type ButtonPropsT = ButtonHTMLAttributes<HTMLButtonElement> & {
  image: string;
  title: string;
  imageStyle?: CSSProperties;
};

type CustomContentT = (handleOpenPopup: (value: boolean) => void) => ReactNode;

interface PropsT {
  buttonList?: ButtonPropsT[];
  customContents?: CustomContentT[];
  menuStyle?: CSSProperties;
}

const EditGeneral: FC<PropsT> = (props) => {
  const { buttonList = [], customContents = [], menuStyle } = props;
  const { t } = useTranslation();

  if (buttonList.length === 0 && customContents.length === 0) return null;

  return (
    <Popup menuStyle={menuStyle}>
      {(handleOpenPopup) => (
        <>
          {Children.toArray(
            buttonList.map(({ title, image, imageStyle, onClick, ...restProps }) => (
              <button
                type="button"
                className={styles.item}
                onClick={(e) => {
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  onClick(e);
                  handleOpenPopup(false);
                }}
                {...restProps}
              >
                <div className={styles.iconWrapper}>
                  <img src={image} alt="img" style={imageStyle} />
                </div>

                <div>{t(title)}</div>
              </button>
            )),
          )}
          {customContents.map((customContent: CustomContentT) => customContent(handleOpenPopup))}
        </>
      )}
    </Popup>
  );
};

export default EditGeneral;
